import isMobile from 'ismobilejs'

/* Wrapper class for the ismobilejs module, but mockable in tests */
export default class MobileDetector {
  static get isMobile() {
    return isMobile().any
  }
}
